var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d9d9d9",
    clipPath: "url(#mail_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.176 23.282a5.7 5.7 0 0 1-3.176.963 5.7 5.7 0 0 1-3.176-.963L.253 12.901 0 12.722v17.011a3.497 3.497 0 0 0 3.498 3.498h31.004A3.497 3.497 0 0 0 38 29.733V12.722l-.253.18zM1.488 11.048l15.571 10.381a3.49 3.49 0 0 0 3.882 0l15.571-10.381A3.33 3.33 0 0 0 38 8.267a3.5 3.5 0 0 0-3.497-3.497H3.497A3.5 3.5 0 0 0 0 8.268a3.33 3.33 0 0 0 1.488 2.779z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mail_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h38v38H0z"
  })))));
};
export default SvgMail;